import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  standardColours,
  minBreakpointQuery,
  fontSize,
  fontWeights,
} from '../styles';
import { Button } from './ui';

const StyledEventSidebar = styled.aside`
  width: 100%;
`;

const StyledContent = styled.div`
  background-color: ${standardColours.lightestGrey};

  ${({ isVenuePage }) => {
    if (isVenuePage) {
      return css`
        padding: 25px;

        ${minBreakpointQuery.small`
          padding: 35px;
        `};

        ${minBreakpointQuery.smedium`
          padding: 45px;
        `};
      `;
    }
  }}
`;

const StyledMapWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
`;

const StyledMap = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

const StyledCta = styled.div`
  padding: 25px;
  background-color: ${standardColours.lightestGrey};
  border-top: solid ${standardColours.grey} 1px;
  text-align: center;

  ${minBreakpointQuery.small`
    padding: 35px;
  `};

  ${minBreakpointQuery.smedium`
    padding: 45px;
  `};
`;

const StyledHeading = styled.h3`
  font-weight: ${fontWeights.regular};
  ${fontSize(16)};
  margin-bottom: 4px;
`;

const StyledButton = styled(Button)`
  margin-top: 10px;
`;

const StyledPhoneNumber = styled.p`
  margin-top: 10px;
`;

const EventSidebar = ({ mapAddress, cta, children, isVenuePage, ...props }) => {
  const {
    datoCmsContactInformation: { phoneNumber },
  } = useStaticQuery(graphql`
    query EventSidebarQuery {
      datoCmsContactInformation {
        phoneNumber
      }
    }
  `);

  return (
    <StyledEventSidebar {...props}>
      {children && (
        <StyledContent isVenuePage={isVenuePage}>{children}</StyledContent>
      )}
      {mapAddress && (
        <StyledMapWrapper>
          <StyledMap
            src={`https://www.google.com/maps/embed/v1/place?key=${process.env.GATSBY_GOOGLE_MAP_API}&q=${mapAddress}`}
            loading="lazy"
          ></StyledMap>
        </StyledMapWrapper>
      )}
      <StyledCta>
        <StyledHeading>{cta.heading}</StyledHeading>
        <StyledButton to={cta.link.pageUrl}>{cta.link.text}</StyledButton>
        <StyledPhoneNumber>or call {phoneNumber}</StyledPhoneNumber>
      </StyledCta>
    </StyledEventSidebar>
  );
};

export default EventSidebar;
